import { Button, Form, Input, Typography, message } from "antd";
import { useTranslation } from "react-i18next";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ApiService } from "../../api";

const ResetPasswordPage = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { token } = useParams();

  const handleSubmit = async (values: any) => {
    try {
      await ApiService.apiPasswordResetConfirmCreate({
        password: values.password,
        token: token!,
      });
      message.success(t("Password has beem changed successfully"));
      navigate("/login");
    } catch (e) {
      message.error(t("Something went wrong."));
    }
  };

  return (
    // Same width and centring as LoginPage (see LoginLayout), so following the
    // reset link doesn't jump the form into the top-left corner.
    <Form
      form={form}
      onFinish={handleSubmit}
      layout="vertical"
      style={{ width: 300 }}
    >
      {/* Same heading treatment as ForgotPasswordPage — they are two steps of
          one flow and should not look like different screens. */}
      <Typography.Title level={4} style={{ marginTop: 0 }}>
        {t("Enter new password")}
      </Typography.Title>
      <Form.Item name="password" label={t("New password")}>
        <Input type="password" />
      </Form.Item>
      <Form.Item style={{ marginBottom: 0 }}>
        <Button type="primary" htmlType="submit" className="login-form-button">
          {t("Change password")}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ResetPasswordPage;
